export default {
  IS_REMINDER_SETTINGS_ENABLED: process.env.REACT_APP_IS_REMINDER_SETTINGS_ENABLED === 'true',
  IS_GRAPH_ENABLED: process.env.REACT_APP_IS_GRAPH_ENABLED === 'true',
  IS_DELEGATE_ENABLED: process.env.REACT_APP_IS_DELEGATE_ENABLED === 'true',
  IS_ASSIGNMENTS_ENABLED: process.env.REACT_APP_IS_ASSIGNMENTS_ENABLED === 'true',
}
